import { gameId, uuidPattern } from './gameplay.mjs';

export const gameplayDrawStorageKey = (scope, id) => `kg_game_draw:v2:${encodeURIComponent(scope)}:${id}`;

// Read the original receipt only. Keep the saved UUID until the participation flow confirms it.
export function createGameplayRecovery({ recover, identity, token, storage, changed = () => {}, withLock }) {
  let version = 0, active = false, activityId = '', confirmed = () => false;
  let value = { requestId: '', result: null, loading: false, waiting: false, error: '' };
  const publish = patch => { value = { ...value, ...patch }; changed(value); };
  function pause() { active = false; confirmed = () => false; version++; publish({ requestId: '', result: null, loading: false, waiting: false, error: '' }); }
  async function open(id) {
    pause(); active = true; activityId = gameId(id);
    const actor = identity(), sessionToken = token(), sequence = version;
    if (!activityId || !actor || !sessionToken) return;
    const key = gameplayDrawStorageKey(actor, activityId);
    let requestId;
    try { requestId = storage.get(key); }
    catch { publish({ error: '上次抽取编号读取失败，请稍后重新查询' }); return; }
    if (!requestId) return;
    if (typeof requestId !== 'string' || !uuidPattern.test(requestId)) {
      publish({ error: '上次抽取编号格式异常，请联系客服核对' }); return;
    }
    const current = () => {
      try { return active && version === sequence && identity() === actor && token() === sessionToken && storage.get(key) === requestId; }
      catch { return false; }
    };
    publish({ requestId, loading: true });
    try {
      // Storage announces a UUID before the action starts. Another tab must not
      // query that receipt until the action releases the same browser lock.
      const lookup = async acquired => {
        if (!current()) return null;
        if (!acquired) { publish({ waiting: true }); return null; }
        return recover(activityId, requestId);
      };
      const result = withLock ? await withLock(`kg-gameplay:${actor}:${activityId}`, lookup) : await lookup(true);
      if (!current()) return;
      if (value.waiting) return;
      if (gameId(result?.activityId) !== activityId || result?.requestId?.toLowerCase() !== requestId.toLowerCase() ||
          !gameId(result?.recordId) || result.action !== 'DRAW' || !['PENDING', 'COMPLETED'].includes(result.status) ||
          !/^\d+(?:\.\d+)?$/.test(String(result.rewardAmount)) ||
          (result.rewardPoints !== undefined && (!Number.isSafeInteger(result.rewardPoints) || result.rewardPoints < 0)) ||
          (result.prizeOrderId && !gameId(result.prizeOrderId))) throw new Error('原抽取结果暂无法核对，请保留请求编号');
      confirmed = current; publish({ result });
    } catch (error) {
      if (current()) publish({ error: error.message || '原抽取结果查询失败，请稍后重新查询' });
    } finally {
      if (current()) publish({ loading: false });
    }
  }
  return { open, pause, canView: () => confirmed() && Boolean(value.result), get value() { return value; } };
}
